import { Box, Divider, Paper, Popover, TextField, Typography } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import SearchButton from "components/buttons/SearchButton";
import ComboBox from "components/ComboBox";
import DateTimeSelect from "components/DateTimeSelect";
import PopoverDefault from "components/PopoverDefault";
import { jobOrderColNm } from "constants/jobOrderConstant";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import dayjs from "dayjs";
import { pettyCashApiNm } from "pages/Menu1/PettyCash/constant";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { SearchRounded } from "resource/muiImport";
import { addIdForDataGrid } from "utils";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import ClearButton from "components/buttons/ClearButton";
import { columns } from "./columns";
import { grey } from "@mui/material/colors";
import DailyJobDialogV3 from "pages/Menu1/DailyJob/DailyJobDialogV3";

const clearSearchJobOrdFilter = {
  ContNo: null,
  JobNo: null,
  Bkg: null,
  POIId: null,
  StsTmSt: null,
  StsTmEn: null,
  AptTmSt: null,
  AptTmEn: null,
}
let initSearchJobOrdFilter = {
  ...clearSearchJobOrdFilter,
  StsTmSt: dayjs().add(-2, "day").format("YYYY-MM-DD"),
  StsTmEn: dayjs().add(1, "day").format("YYYY-MM-DD"),
  AptTmSt: dayjs().add(-180, "day").format("YYYY-MM-DD"),
  AptTmEn: dayjs().add(90, "day").format("YYYY-MM-DD"),
}

let pcItemList = []
let selectedJobOrdId = null
const PopoverSearchJobOrder = ({ onOpen, handleSelectJobOrder, suggestDrvId, suggestPOIIds }) => {
  const { ax, msData } = useContext(GlobalStateContext)

  const [searchJobOrdFilter, setSearchJobOrdFilter] = useState({ ...initSearchJobOrdFilter })
  const [searchJobOrdResult, setSearchJobOrdResult] = useState([])
  const [dialogDailyJobOpen, setDialogDailyJobOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const pcItemListOpen = Boolean(anchorEl);

  const refSearchJobOrder = useRef(null)

  const suggestDrvCombo = useMemo(() => {
    if (!suggestDrvId) return msData.driverCombo
    const result = []
    for (const drv of msData.driverCombo) {
      if (drv.id === suggestDrvId) {
        result.unshift({ ...drv, group: "แนะนำ" })
      } else {
        result.push({ ...drv })
      }
    }
    return result
  }, [suggestDrvId, msData.driverCombo])

  const suggestPOICombo = useMemo(() => {
    if (!suggestPOIIds || suggestPOIIds.length === 0) return msData.poiCombo
    const suggestPOIs = msData.poiCombo.filter(poi => suggestPOIIds.includes(poi.id))
      .map(poi => ({ ...poi, group: "แนะนำ" }))
    const otherPOIs = msData.poiCombo.filter(poi => !suggestPOIIds.includes(poi.id))
    return [...suggestPOIs, ...otherPOIs]
  }, [suggestPOIIds, msData.poiCombo])

  const handleSearchJobOrder = useCallback((filter) => {
    ax.post(pettyCashApiNm.getFindClearReceipt, filter).then(value => {
      if (value.data) {
        setSearchJobOrdResult(addIdForDataGrid(value.data, "JobOrdId"))
      }
    })
  }, [ax])

  const filterProps = useCallback((name) => {
    return {
      label: jobOrderColNm[name],
      size: "small",
      value: searchJobOrdFilter[name] ?? "",
      onChange: (e) => setSearchJobOrdFilter(o => ({ ...o, [name]: e.target.value })),
      onKeyUp: (e) => {
        e.stopPropagation()
        if (e.key === "Enter") {
          handleSearchJobOrder(searchJobOrdFilter)
        }
      },
      sx: { flex: 1 },
    }
  }, [handleSearchJobOrder, searchJobOrdFilter])

  const handleClose = useCallback(() => {
    setSearchJobOrdResult([])
    refSearchJobOrder.current.close()
  }, [])

  const handleCellClick = useCallback(({ id, field, row }, e) => {
    e.stopPropagation()
    if (field === "ShowDetail") {
      selectedJobOrdId = id
      setDialogDailyJobOpen(true)
    } else if (field === "JobOrdId") {
      handleSelectJobOrder(row)
      handleClose()
    } else if (field === "PCItemsStr") {
      setAnchorEl(e.currentTarget)
      pcItemList = row.PCItems || []
    }
  }, [handleClose, handleSelectJobOrder])

  useEffect(() => {
    setSearchJobOrdFilter(o => ({ ...o, DrvId: suggestDrvId }))
  }, [suggestDrvId])
  return (
    <PopoverDefault ref={refSearchJobOrder} icon={<SearchRounded />} onOpen={onOpen} onClose={handleClose}>
      <Paper sx={{ p: 1, width: 1150, maxHeight: 400, overflowY: "auto" }}>
        <BoxFC sx={{ gap: 1 }}>
          <BoxFR>
            <ComboBox sx={{ width: 150 }} options={suggestDrvCombo} label={jobOrderColNm.DrvNm}
              selectedId={searchJobOrdFilter.DrvId}
              setSelectedId={(id) => setSearchJobOrdFilter(o => ({ ...o, DrvId: id }))}
            />
            <ComboBox sx={{ width: 150 }} options={suggestPOICombo} label="สถานที่"
              selectedId={searchJobOrdFilter.POIId}
              setSelectedId={(id) => setSearchJobOrdFilter(o => ({ ...o, POIId: id }))}
            />
            <DateTimeSelect
              initRadioValue="RANGE"
              sx={{ width: 180 }}
              label="วันที่วิ่งงาน"
              start={searchJobOrdFilter.StsTmSt}
              end={searchJobOrdFilter.StsTmEn}
              setSelectDate={(st, en) => { setSearchJobOrdFilter(o => ({ ...o, StsTmSt: st, StsTmEn: en })) }}
              getData={() => { handleSearchJobOrder(searchJobOrdFilter) }}
            />
            <TextField {...filterProps("ContNo")} />
            <TextField {...filterProps("JobNo")} />
            <TextField {...filterProps("Bkg")} />
            <SearchButton onClick={() => { handleSearchJobOrder(searchJobOrdFilter) }} />
            <ClearButton onClick={() => { setSearchJobOrdFilter({ ...clearSearchJobOrdFilter, }) }} />
          </BoxFR>
          <Divider width="90%" sx={{ alignSelf: "center", pt: 1, mb: 1 }} />
          <Box sx={{ width: "100%", height: 300 }}>
            <DataGridCellExpand
              columns={columns}
              rows={searchJobOrdResult}
              onCellClick={handleCellClick}
              hideToolbar
              hideFooter
              disableContextMenu={true}
            />
          </Box>
        </BoxFC>
        <Popover
          open={pcItemListOpen}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
        >
          <Paper sx={{ p: 1, width: 400 }}>
            <Typography variant="body2" fontWeight="bold">รายการค่าใช้จ่าย</Typography>
            {
              pcItemList.map((item, index) => (
                <BoxFR key={index} borderBottom={1} borderColor={grey[400]}>
                  <Typography variant="body2" sx={{ width: 30, textAlign: "center" }}>{index + 1}.</Typography>
                  <Typography variant="body2" sx={{ width: 80 }}>{item.UsrAccNNm}</Typography>
                  <Typography variant="body2" sx={{ flex: 1 }}>{item.ExpNm}</Typography>
                  <Typography variant="body2" sx={{ width: 100, textAlign: "right" }}>{item.PayAmnt?.toLocaleString()}</Typography>
                </BoxFR>
              ))
            }

          </Paper>
        </Popover>
        <DailyJobDialogV3
          selectedId={selectedJobOrdId}
          dialogOpen={dialogDailyJobOpen}
          setDialogOpen={setDialogDailyJobOpen} />
      </Paper>
    </PopoverDefault>
  )
}

export default React.memo(PopoverSearchJobOrder);